import { Controller } from '@hotwired/stimulus'

export default class OmniauthLinksController extends Controller {
  static targets = [
    'browserLinksContainer',
    'appLinksContainer',
    'appleConnectButton',
    'googleConnectButton',
  ];

  connect() {
    if (navigator.userAgent.indexOf('onebrick') >= 0) {
      this.browserLinksContainerTarget.remove();

      if (!navigator.userAgent.match(/iPhone|iPad/)) {
        this.appleConnectButtonTarget.remove();
      }
    } else {
      this.appLinksContainerTarget.remove();
    }
  }
}
